import { render, staticRenderFns } from "./IssueTopicField.vue?vue&type=template&id=161173eb"
import script from "./IssueTopicField.vue?vue&type=script&lang=js"
export * from "./IssueTopicField.vue?vue&type=script&lang=js"
import style0 from "./IssueTopicField.vue?vue&type=style&index=0&id=161173eb&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports